import { useEffect } from 'react';

interface PollingConfig {
	focusedInterval?: number; // in milliseconds
	blurredInterval?: number; // in milliseconds
}

const DEFAULT_CONFIG: PollingConfig = {
	focusedInterval: 5000,
	blurredInterval: 60000,
};

export const usePollingRefresh = (refreshFn: () => void, config: PollingConfig = DEFAULT_CONFIG) => {
	useEffect(() => {
		let intervalId: NodeJS.Timeout;

		const startPolling = (interval: number) => {
			if (intervalId) {
				clearInterval(intervalId);
			}
			intervalId = setInterval(refreshFn, interval);
		};

		const handleVisibilityChange = () => {
			if (document.hidden) {
				startPolling(config.blurredInterval ?? DEFAULT_CONFIG.blurredInterval);
			} else {
				startPolling(config.focusedInterval ?? DEFAULT_CONFIG.focusedInterval);
			}
		};

		startPolling(
			document.hidden
				? (config.blurredInterval ?? DEFAULT_CONFIG.blurredInterval)
				: (config.focusedInterval ?? DEFAULT_CONFIG.focusedInterval)
		);

		document.addEventListener('visibilitychange', handleVisibilityChange);

		return () => {
			if (intervalId) {
				clearInterval(intervalId);
			}
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, [refreshFn, config.focusedInterval, config.blurredInterval]);
};
